;(function (window, APP, Backbone, Marionette, $, _) {
	'use strict';

	var View = APP.module('View');

	View.LeaguesJoinFilter = Marionette.ItemView.extend({
		template: null,
		ui: {
			'private_input':  '',
			'private_submit': '',
			'public_input':   '',
			'public_submit':  ''
		},
		events: {
			'keyup @ui.private_input':  'changedFilter',
			'click @ui.private_submit': 'changedFilter',
			'keyup @ui.public_input':   'changedFilter',
			'click @ui.public_submit':  'changedFilter',
			'change @ui.public_input':  'changedFilter',
		},
		changedFilter: function(e) {

			if ((e.type == 'keyup' && e.keyCode == 13) || e.type == 'click' || e.type == 'change') {
				var $el = $(e.currentTarget),
					is_private = $el.is(this.ui.private_input) || $el.is(this.ui.private_submit),
					input = is_private ? this.ui.private_input : this.ui.public_input;

				(!is_private ? this.ui.private_input : this.ui.public_input).val('');
				APP.vent.trigger('leagues_join_filter:change', { q: input.val().trim() });
			}

			return this;
		},
	});

}(window, APP, Backbone, Marionette, $, _));